import axios from '../axios';
import mainAxios from 'axios';

export const all = (params = {}) => {
  return axios.get('/admin-shops', { params });
};

export const show = (id) => {
  return axios.get(`/admin-shops/${id}`);
};

export const update = (id, payload) => {
  return axios.post(`/admin-shops/${id}`, payload);
};

export const updateShouldUpdate = (id) => {
  return axios.put(`/admin-shops/${id}/should-update`);
};

export const create = (payload) => {
  return axios.post('/admin-shops', payload);
};

export const destroy = (id) => {
  return axios.delete(`/admin-shops/${id}`);
};

export const getLocation = (query) => {
  return mainAxios.get(`https://api.mapbox.com/search/geocode/v6/forward?q=${query}&access_token=${process.env.VUE_APP_MAPBOX_ACCESS_TOKEN}`)
};
